import { GET_THIRD_PARTY_LIST, CREATE_ACCOUNT, EDIT_ACCOUNT, DISABLE_EDIT } from './actions';

import { REQUEST, SUCCESS } from '../../../utils/actionGenerator';

const defaultState = {
  thirdPartyList: [],
  accountCreated: false,
  accountEdited: false,
  editDisabled: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_THIRD_PARTY_LIST[REQUEST]:
      return { ...state };
    case GET_THIRD_PARTY_LIST[SUCCESS]:
      return { ...state, thirdPartyList: action.response };
    case CREATE_ACCOUNT[REQUEST]:
      return { ...state, accountCreated: false };
    case CREATE_ACCOUNT[SUCCESS]:
      return { ...state, accountCreated: true };
    case EDIT_ACCOUNT[REQUEST]:
      return { ...state, accountEdited: false };
    case EDIT_ACCOUNT[SUCCESS]:
      return { ...state, accountEdited: true };
    case DISABLE_EDIT[REQUEST]:
      return { ...state, editDisabled: false };
    case DISABLE_EDIT[SUCCESS]:
      return { ...state, editDisabled: true };
    default:
      return state;
  }
}

export const getThirdPartyList = (state) => state.thirdParty.thirdPartyList;
export const getThirdPartyReducer = (state) => state.thirdParty;
